import { deriveAgentsEmbedUrl } from './agents-embed-origin';
import { deriveBaseIamUrl } from './base-iam-origin';

export const environment = {
  production: true,
  version: '892c826163a9061cdb4c9ec35a3faf9534ad187d',
  weatherApiKey: 'ecd5bb0efd934aea9a5122330232811',
  weatherApiUrl: 'https://api.weatherapi.com/v1',
  apiBaseUrl: '/api',
  apiPublicUrl: '/api/public',
  apiBaseAdminUrl: '/api/admin',
  baseIamUrl: getBaseIamUrl(),
  apiAirQualityUrl: 'https://airquality.googleapis.com/v1',
  agentsEmbedUrl: getAgentsEmbedUrl(),
  accessibilityStatementUrl: 'https://www.gridwatchems.com/accessibility',
};

// BRN-2118 (base-domain DNS-deduction): BRAIN's IAM base URL, hostname-derived at runtime -- the
// same STRUCTURAL transform as getAgentsEmbedUrl() below (deriveBaseIamUrl: drop the tenant label,
// swap the product label brain -> iam), replacing the previous `host.includes('qa')` qa/prod string
// test + hardcoded per-env domain literals. So qa, prod, AND any future commissioned/private-cloud
// environment resolve automatically with no per-env branch and no gridwatchems.com literal. See
// base-iam-origin.ts for the single-tenant-label assumption (flagged for operator confirmation).
function getBaseIamUrl(): string {
  return deriveBaseIamUrl(window.location.hostname);
}

// BRN-2118 (AC1, AC7): brain-agents-web's embed origin, hostname-derived at runtime -- the exact
// same pattern as getBaseIamUrl() above, matching design.md's "BRAIN derives per-env URLs from
// hostname at runtime (environment.ts pattern, as with IAM today)". The derivation is STRUCTURAL
// (deriveAgentsEmbedUrl: drop the tenant label, swap the product label brain -> agents), never a
// qa/prod string test, so qa, prod, AND any future commissioned environment resolve automatically
// with no per-env branch. See agents-embed-origin.ts for the single-tenant-label assumption
// (flagged for operator confirmation).
function getAgentsEmbedUrl(): string {
  return deriveAgentsEmbedUrl(window.location.hostname);
}
